<template>
  <section class="clearfix Pagination">
    <button
      class="Previous"
      @click="
        this.sdgPlansData.page.currentPage !== 1
          ? [ gotoPage(this.sdgPlansData.page.currentPage - 1), scrollToTop() ]
          : null
      "
    ></button>
    <span> {{ this.sdgPlansData.page.currentPage }}</span>/
    <span>{{ totalPage }}</span>
    <button
      class="Next"
      @click="
        this.sdgPlansData.page.currentPage !== totalPage
          ? [ gotoPage(this.sdgPlansData.page.currentPage + 1), scrollToTop() ]
          : null
      "
    ></button>
  </section>
</template>

<script>
import { useDataContext } from '@/composable/plans'; 

export default {
  name: 'SDGPaginationComponent',
  setup() {
    return useDataContext(); 
  },
  methods: {
    gotoPage(pageNo) {
      this.sdgPlansData.page.currentPage = pageNo;
    },
    refresh() {
      window.location.reload();
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  computed: {
    totalPage: function () {
      let roundedNo = Math.ceil(
        this.sdgPlansData.planItems.length === 0 ? 1 : this.sdgPlansData.planItems.length / this.sdgPlansData.page.pageSize
      );
      return roundedNo;
    },
  },
};
</script>

<style>

</style>
